import {
  type AppTemplate,
  DevelopmentTool,
} from '@wix/ambassador-devcenter-apps-v1-app-template/types';

export const isBlocksTemplate = (template: AppTemplate) =>
  template?.developmentTools?.includes(DevelopmentTool.BLOCKS);

export const isTemplateRequiresNamespace = (template: AppTemplate) =>
  template.namespaceRequired;

export const isBlocksTemplateRequiresNamespace = (template: AppTemplate) =>
  isBlocksTemplate(template) && isTemplateRequiresNamespace(template);

export const isCLITemplate = (template: AppTemplate) =>
  template?.developmentTools?.includes(DevelopmentTool.CLI);

export const isSelfHostedTemplate = (template: AppTemplate) =>
  template?.developmentTools?.includes(DevelopmentTool.DEV_CENTER);
